export const breakpoints = {
  desktop: 960,
  tablet: 600
}

export const mediaQueries = {
  desktop: `@media(min-width: ${breakpoints.desktop}px)`,
  tablet: `@media(max-width: ${breakpoints.desktop - 1}px) and (min-width: ${breakpoints.tablet + 1}px)`,
  mobile: `@media(max-width: ${breakpoints.tablet}px)`,
  notMobile: `@media(min-width: ${breakpoints.tablet + 1}px)`
}